(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("ino7v", function(module, exports) {
const $d60d15bc7ef76fdc$var$observerSettings = {
    threshold: 0
};
const $d60d15bc7ef76fdc$var$callback = (entries)=>{
    entries.forEach((entry)=>{
        entry.target.classList.toggle("--view-hidden", !entry.isIntersecting);
    });
};
const $d60d15bc7ef76fdc$var$observer = new IntersectionObserver($d60d15bc7ef76fdc$var$callback, $d60d15bc7ef76fdc$var$observerSettings);
const $d60d15bc7ef76fdc$var$groups = document.querySelectorAll(".g-testimonials.--infinite");
$d60d15bc7ef76fdc$var$groups.forEach((group)=>{
    $d60d15bc7ef76fdc$var$observer.observe(group);
    const inner = group.querySelector(".g-testimonials__inner");
    const items = group.querySelectorAll(".i-testimonial");
    if (!inner) return;
    items.forEach((item)=>{
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", "true");
        inner.appendChild(duplicatedItem);
    });
});

});

})();
//# sourceMappingURL=testimonials-group--infinite.b8d64ebe.js.map
